<div class="container-fluid new-hire-container">
  <div class="row">
    <div class="col">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a routerLink="/plans">
            {{"plan.page.title" | translate}}
          </a>
          <svg style="width: 14px;height: 14px;margin-left: 3px; fill:#212529">
            <use xlink:href="#icon-arrow-right"/>
          </svg>
          <a [routerLink]="['..']">
            {{planName}}
          </a>
        </li>
      </ol>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col page-header plan-detail">
      <wfm-page-title title="{{'new.hire.page.title'|translate}}"></wfm-page-title>
    </div>
    <div class="col text-right">

      <button id="return-to-plan" class="btn btn-secondary btn-lg no-right-margin" [routerLink]="['..']" title='{{"plan.dist.return.plan" | translate}}'>{{"plan.dist.return.plan" | translate}}</button>
      <button id="apply" (click)="applyChanges()" [ngClass]="{'disabled': _isLoading  || !hasModifications || _isLoadingError}"
              class="btn btn-primary btn-lg no-right-margin" [disabled]="_isLoading  || !hasModifications" title='{{"plan.apply.btn" | translate}}'>{{"plan.apply.btn" | translate}}</button>

    </div>
  </div>
  <div class="row toolbar-container no-gutters">
    <div class="vertical-align-middle">
      <span class="toolbar-label" >{{"plan.dist.mu.dropdown.label" | translate}}</span>
      <p-multiselect placeholder=" " #muSelector
                     class="filterable toolbar-select no-x-scroll mu-multiselect"
                     [ariaLabel]="'plan.dist.mu.dropdown.label' | translate"
                     [(ngModel)]="selectedMUs"
                     ngDefaultControl
                     appendTo="body"
                     [options]="managementUnitsList"
                     [showToggleAll]="false"
                     [virtualScroll]="true"
                     [virtualScrollItemSize]="40"
                     [virtualScrollOptions]="virtualScrollOptions"
                     scrollHeight="200px"
                     panelStyleClass="esp-multiselect-fixed-height"
                     optionLabel="value.label"
                     optionValue="value"
                     (onChange)="updateSelectedMUs()"
                     (onPanelHide)="muSelectorClosed()"
                     [showHeader]="true"
                     [filter]="false"
                     [disabled]="!_isGridValid || _isLoading || _isLoadingError"
                     [overlayOptions]="{showTransitionOptions: '0ms', hideTransitionOptions: '0ms'}"
                     emptyFilterMessage="{{'plan.details.dropdown.management.units.empty' | translate}}"
                     styleClass="fullrow">
        <ng-template let-value pTemplate="selectedItems">
          <esp-multi-select-content [items]="value" emptyMessage="plan.details.dropdown.management.units.empty.selection"> </esp-multi-select-content>
        </ng-template>
        <ng-template pTemplate="header">
          <esp-multi-select-filter [multiSelect]="muSelector">

          </esp-multi-select-filter>
        </ng-template>
        <ng-template pTemplate="footer">
          <esp-multi-select-footer [multiSelect]="muSelector">

          </esp-multi-select-footer>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <esp-multi-select-item [item]="item"></esp-multi-select-item>
        </ng-template>
      </p-multiselect>
    </div>
    <div class="text-right">
      <button id="export-btn"
              class="btn btn-secondary no-right-margin"
              [disabled]="_isLoading || _isLoadingError || !hasClasses"
              (click)="onBtnExport()"
              title="{{'plan.exportcsv' | translate}}">
        <i class="icon icon-CSV"></i>
      </button>
      <breeze-button buttonText="{{'plan.dist.discard.btn'|translate}}"
                     id="discard-btn"
                     *ngIf="!isReadOnly"
                     [isSecondary]="true"
                     [isDisabled]="_isLoading || !hasModifications || _isLoadingError"
                     (clicked)="showDiscardDlg()"></breeze-button>
      <breeze-button buttonText="{{'new.hire.add.learning.curve'|translate}}"
                     [isDisabled]="_isLoading || _isLoadingError"
                     [isSecondary]="true"
                     (clicked)="showAddLearningCurveDlg()">

      </breeze-button>
    </div>
  </div>
  <div class="row" >
    <div class="col" style="">
      <div class="table-list editable-grid multi-cell-edit" >
        <ag-grid-angular class="ag-theme-balham" style="width: 100%; height: calc(100vh - 220px);"
                         [rowData]="rowData"
                         #grid

                         [rowHeight]="36" [headerHeight]="39"
                         [columnDefs]="colDefs"
                         [gridOptions]="gridOptions"
                         [suppressRowTransform]="true"
                         suppressCopyRowsToClipboard="true"
                         [enableRangeSelection]="true"
                         [modules]="modules"
                         [treeData]="true"
                         enableRangeSelection="true"
                         enableFillHandle="false"
                         [stopEditingWhenCellsLoseFocus]="true"
                         [loadingOverlayComponent]="PlanLoadingOverlayComponent"
                         [components]="frameworkComponents"
                         [groupRowRendererParams]="groupRowRendererParams"
                         [noRowsOverlayComponent]="EspNoRowsOverlayComponent"
                         [noRowsOverlayComponentParams]="noRowsComponentParams"
                         (gridReady)="onGridReady($event)"
                         [icons]="icons"
                         [enableBrowserTooltips]="true"
                         [animateRows]="false">
        </ag-grid-angular>

      </div>
    </div>
  </div>
</div>
<div class="dialog-container"></div>
<div class="overlay-panel" *ngIf="_isLoading">
  <wfm-esp-loading-rows-overlay></wfm-esp-loading-rows-overlay>
</div>
<wfm-task-progress [task]="task" *ngIf="task && planDetails" [canCancel]="false">

</wfm-task-progress>
<p-toast position="bottom-right" [baseZIndex]="1060">
</p-toast>
